module.exports = "https://static.zego.com/_next/static/images/Backdrop-86debb4f6f78479adb146bd658dcf55a.svg";